import React, { useState } from "react";
import { seriesList } from "../../utils/seriesList";

const CATEGORY_OPTIONS = [
        { value: "SportsCar", label: "Sports Car" },
        { value: "FormulaCar", label: "Formula Car" },
        { value: "Oval", label: "Oval" },
        { value: "DirtRoad", label: "Dirt Road" },
        { value: "DirtOval", label: "Dirt Oval" },
];

const TIME_FRAME_OPTIONS = [
        { value: "All Time", label: "All Time" },
        { value: "1 Year", label: "1 Year" },
        { value: "2 Years", label: "2 Years" },
        { value: "3 Years", label: "3 Years" },
];

function WidgetConfigModal({ widgetType, onSave, onCancel }) {
        const [config, setConfig] = useState(getDefaultConfig(widgetType));
        const [seriesSearch, setSeriesSearch] = useState("");

        const handleChange = (field, value) => {
                setConfig((prev) => ({ ...prev, [field]: value }));
        };

        const handleSave = () => {
                onSave(config);
        };

        const handleOverlayClick = (e) => {
                if (e.target === e.currentTarget) {
                        onCancel();
                }
        };

        const renderConfigFields = () => {
                switch (widgetType) {
                        case "irating_distribution":
                                return (
                                        <>
                                                <div className="config-field">
                                                        <label>Category</label>
                                                        <select value={config.category} onChange={(e) => handleChange("category", e.target.value)}>
                                                                {CATEGORY_OPTIONS.map((opt) => (
                                                                        <option key={opt.value} value={opt.value}>
                                                                                {opt.label}
                                                                        </option>
                                                                ))}
                                                        </select>
                                                </div>
                                                <div className="config-field">
                                                        <label>Time Frame</label>
                                                        <select value={config.timeFrame} onChange={(e) => handleChange("timeFrame", e.target.value)}>
                                                                {TIME_FRAME_OPTIONS.map((opt) => (
                                                                        <option key={opt.value} value={opt.value}>
                                                                                {opt.label}
                                                                        </option>
                                                                ))}
                                                        </select>
                                                </div>
                                        </>
                                );

                        case "lap_times_boxplot": {
                                const filteredSeries = seriesList.filter((s) => s.toLowerCase().includes(seriesSearch.toLowerCase()));
                                return (
                                        <div className="config-field">
                                                <label>Series</label>
                                                <input
                                                        type="text"
                                                        value={seriesSearch}
                                                        onChange={(e) => setSeriesSearch(e.target.value)}
                                                        placeholder="Search series..."
                                                        className="config-series-search"
                                                />
                                                <select value={config.seasonName} onChange={(e) => handleChange("seasonName", e.target.value)} size={8} className="config-series-select">
                                                        {filteredSeries.map((series) => (
                                                                <option key={series} value={series}>
                                                                        {series}
                                                                </option>
                                                        ))}
                                                </select>
                                        </div>
                                );
                        }

                        case "career_stats":
                                return (
                                        <div className="config-field">
                                                <label>Customer ID</label>
                                                <input type="text" value={config.custId} onChange={(e) => handleChange("custId", e.target.value)} placeholder="Enter iRacing Customer ID" />
                                                <small>Your own Customer ID, or one belonging to a driver who has opted in to sharing their profile.</small>
                                        </div>
                                );

                        default:
                                return <p>No configuration needed for this widget.</p>;
                }
        };

        const getTitle = () => {
                switch (widgetType) {
                        case "irating_distribution":
                                return "Configure iRating Distribution";
                        case "lap_times_boxplot":
                                return "Configure Lap Times";
                        case "career_stats":
                                return "Configure Career Stats";
                        default:
                                return "Configure Widget";
                }
        };

        return (
                <div className="widget-config-overlay" onClick={handleOverlayClick}>
                        <div className="widget-config-modal">
                                <div className="widget-config-header">
                                        <h2>{getTitle()}</h2>
                                        <button className="widget-config-close" onClick={onCancel}>
                                                &times;
                                        </button>
                                </div>

                                <div className="widget-config-body">{renderConfigFields()}</div>

                                <div className="widget-config-footer">
                                        <button className="btn-cancel" onClick={onCancel}>
                                                Cancel
                                        </button>
                                        <button className="btn-save" onClick={handleSave}>
                                                Add Widget
                                        </button>
                                </div>
                        </div>
                </div>
        );
}

function getDefaultConfig(widgetType) {
        switch (widgetType) {
                case "irating_distribution":
                        return {
                                category: "SportsCar",
                                timeFrame: "All Time",
                        };
                case "lap_times_boxplot":
                        return {
                                seasonName: "GT Sprint Series by Simucube - 2026 Season 4",
                        };
                case "career_stats":
                        return {
                                custId: "",
                        };
                default:
                        return {};
        }
}

export default WidgetConfigModal;
